<script lang="ts">
  // Carte des ports d'entrée américains : fond des États (us-atlas, projection Albers USA calculée d'avance dans
  // lib/usmap.json) et un cercle par district douanier, de surface proportionnelle à la valeur importée.
  // Porto Rico et les îles Vierges, hors projection, sont en encart en bas à droite. Infobulle native.
  import GEO from '../lib/usmap.json';
  import { usd, pct } from '../lib/format';
  import { t, tf } from '../lib/i18n.svelte';

  let { rows, year }: { rows: { r: string; n: string; v: number; sh: number }[]; year: string } = $props();
  const G = GEO as unknown as { w: number; h: number; f: { n: string; d: string }[]; pts: Record<string, [number, number]> };
  const RMAX = 34;

  const vmax = $derived(Math.max(1, ...rows.map((r) => r.v)));
  // Grands cercles d'abord : les petits restent visibles par-dessus.
  const dots = $derived(rows.filter((r) => r.v > 0 && G.pts[r.r]).map((r) => ({ ...r, x: G.pts[r.r][0], y: G.pts[r.r][1], rad: Math.max(2.2, Math.sqrt(r.v / vmax) * RMAX) })).sort((a, b) => b.v - a.v));
</script>

<svg viewBox="0 0 {G.w} {G.h}" width="100%" class="us-map" role="img">
  {#each G.f as f (f.n)}<path d={f.d}><title>{f.n}</title></path>{/each}
  <text class="us-inset" x={G.w - 8} y={G.h - 40} text-anchor="end">{t('map.pr')}</text>
  {#each dots as d (d.r)}
    <circle cx={d.x} cy={d.y} r={d.rad}><title>{d.n} : {usd(d.v)} ({pct(d.sh)})</title></circle>
  {/each}
</svg>
<div class="fr-maplegend">{tf('map.bubble', { y: year })}</div>
